import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, styled } from '../../utils';
import { FormGrid } from '../FormGrid';
// TODO: maybe should datatable decide about padding and border?
const FormGridStyled = styled(FormGrid, {
    shouldForwardProp: (prop) => prop !== 'noHorizontalPadding' &&
        prop !== 'paddingMobile' &&
        prop !== 'striped',
    name: 'FormGridStyled',
})(({ theme, noHorizontalPadding, paddingMobile, striped }) => ({
    padding: noHorizontalPadding
        ? theme.spacing(2.5, 0)
        : theme.spacing(1.5, 1.5, 1.5, 1.5),
    ':nth-of-type(odd)': {
        background: striped
            ? alpha(theme.palette.groupPrimary.skyBlue, 0.05)
            : 'inherit',
    },
    '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.secondary.contrastText}`,
    },
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(paddingMobile ?? 1.5),
        gap: theme.spacing(1),
        ':nth-of-type(odd)': {
            background: 'inherit',
        },
    },
}));
export const DataTableRow = (props) => {
    const { children, rowGap, minWidth, columnGap, className, striped = true, paddingMobile, } = props;
    const formGridProps = {
        rowGap,
        minWidth,
        columnGap,
        className,
        striped,
        paddingMobile,
    };
    return _jsx(FormGridStyled, { ...formGridProps, children: children });
};
